<template>
  <div class="text-gray-800 h-full" v-if="i18n != undefined">
    <div class="h-full relative">
      <div
        class="absolute top-0 right-0 flex items-center text-center py-5 justify-start"
      >
        <div class="text-center block">
          <div
            class="w-full flex justify-center text-xs text-center items-center"
          >
            <button
              @click="loadData"
              class="text-xs text-center items-center border border-solid border-gray-200 rounded p-1 bg-gray-100"
              style="font-size: 12px"
            >
              {{ i18n.next_update_in }}
              <span v-if="!refreshing" class="px-1">{{
                refresh_remaining
              }}</span>
              <span v-if="refreshing" class="px-1">
                <font-awesome-icon icon="spinner" spin
              /></span>
              {{ i18n.seconds }}
            </button>
          </div>
        </div>
      </div>
      <tabs
        :options="{ useUrlFragment: false }"
        class="queue h-full pt-5 flex flex-col"
      >
        <tab :name="i18n.power_farm" class="">
          <FarmQueue
            :loaded="loaded"
            :i18n="i18n"
            :rendering="rendering_by_farm.power"
            :queued="power"
            @selected="$emit('selected', arguments[0])"
          />
        </tab>
        <tab :name="i18n.gpu_farm" class="">
          <FarmQueue
            :loaded="loaded"
            :i18n="i18n"
            :rendering="rendering_by_farm.gpu"
            :queued="gpu"
            @selected="$emit('selected', arguments[0])"
          />
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handleAxiosError } from "@/boot/functions";

import FarmQueue from "./_FarmQueue";

export default {
  props: [],
  components: { FarmQueue },
  data() {
    return {
      loaded: false,
      data: [],
      rendering_by_farm: [],
      power: undefined,
      gpu: undefined,
      date: "",
      refresh_remaining: this.refreshTime,
      refreshing: false,
    };
  },
  methods: {
    loadData() {
      if (this.refreshing || this.refreshTime < this.refresh_remaining + 5) {
        return;
      }
      this.refreshing = true;
      axios
        .get(this.endpoint)
        .then(({ data: { data } }) => {
          this.data = data;
          this.date = data.date;
          this.power = data.queued.power;
          this.gpu = data.queued.gpu;
          this.rendering_by_farm = data.rendering_by_farm;
          this.loaded = true;
        })
        .catch(handleAxiosError)
        .then(this.startRefreshCountdown);
    },

    countdown() {
      this.refresh_remaining--;
      if (this.refresh_remaining == 0) {
        this.loadData();
        return;
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.countdown, 1000);
    },

    startRefreshCountdown() {
      this.refreshing = false;
      this.refresh_remaining = this.refreshTime;
      this.countdown();
    },
  },

  computed: {
    endpoint() {
      return this.$store.state.dashboard.projects.routes.queue;
    },
    i18n() {
      return this.$store.state.queue.i18n;
    },
    refreshTime() {
      return this.$store.state.queue.refreshRate;
    },
  },

  mounted() {
    this.loadData();
  },
  destroyed() {
    clearTimeout(this.timeout);
  },
};
</script>
